import { Link } from "react-router-dom";
import { Page, H1, H2, Lead, P, UL, Notice, Toc, DocVersion } from "../../public/primitives";
import { legal } from "../../../config/legal";

export const TermsPage = () => (
  <Page testid="terms-page">
    <H1>Conditions générales d'utilisation</H1>
    <Lead>Version <DocVersion value={legal.termsVersion} /> — dernière mise à jour {legal.lastUpdated}.</Lead>

    <Toc
      items={[
        { id: "objet", label: "Objet" },
        { id: "acces", label: "Accès" },
        { id: "usage-sans-compte", label: "Usage sans compte" },
        { id: "compte", label: "Compte" },
        { id: "obligations", label: "Obligations" },
        { id: "protection-liens", label: "Protection des liens" },
        { id: "usages-interdits", label: "Usages interdits" },
        { id: "disponibilite", label: "Disponibilité" },
        { id: "evolution", label: "Évolution" },
        { id: "suspension", label: "Suspension" },
        { id: "propriete", label: "Propriété intellectuelle" },
        { id: "responsabilite", label: "Responsabilité" },
        { id: "donnees", label: "Données personnelles" },
        { id: "droit-applicable", label: "Droit applicable" },
      ]}
    />

    <H2 id="objet">Objet</H2>
    <P>
      Les présentes conditions encadrent l'utilisation de SecurePass, service permettant de créer des
      liens sécurisés et temporaires pour transmettre ou recevoir des informations sensibles.
    </P>

    <H2 id="acces">Accès au service</H2>
    <P>Le service est accessible en ligne, sans installation, via un navigateur récent.</P>

    <H2 id="usage-sans-compte">Usage sans compte</H2>
    <P>
      Un usage ponctuel est possible sans compte (durées limitées, absence d'historique, limites
      anti-abus). Voir le <Link to="/documentation" className="text-emerald-600 underline">Centre d'aide</Link>.
    </P>

    <H2 id="compte">Création d'un compte</H2>
    <P>La création d'un compte donne accès à l'historique, aux espaces de travail et aux options avancées.</P>

    <H2 id="obligations">Obligations de l'utilisateur</H2>
    <UL>
      <li>Fournir des informations exactes lors de la création d'un compte.</li>
      <li>Préserver la confidentialité de ses identifiants.</li>
      <li>Utiliser le service conformément à la loi et aux présentes conditions.</li>
    </UL>

    <H2 id="protection-liens">Protection et transmission des liens</H2>
    <P>
      L'utilisateur est responsable des liens qu'il génère et des destinataires auxquels il les
      transmet. Toute personne disposant du lien complet peut accéder à l'information tant qu'elle est
      disponible.
    </P>

    <H2 id="usages-interdits">Usages interdits</H2>
    <UL>
      <li>Activités illicites ou portant atteinte aux droits de tiers.</li>
      <li>Tentatives de contournement des mesures de sécurité ou anti-abus.</li>
      <li>Usage nuisant au bon fonctionnement du service.</li>
    </UL>

    <H2 id="disponibilite">Disponibilité</H2>
    <P>Le service est fourni dans la limite du raisonnable, sans garantie de disponibilité continue.</P>

    <H2 id="evolution">Évolution du service</H2>
    <P>Les fonctionnalités peuvent évoluer, être ajoutées ou retirées.</P>

    <H2 id="suspension">Suspension en cas d'abus</H2>
    <P>Un usage abusif peut entraîner une limitation ou une suspension de l'accès.</P>

    <H2 id="propriete">Propriété intellectuelle</H2>
    <P>Les éléments du service sont protégés et réservés à {legal.publisherName}.</P>

    <H2 id="responsabilite">Responsabilité</H2>
    <P>
      La responsabilité de {legal.publisherName} s'apprécie dans les limites prévues par la loi
      applicable. L'utilisateur reste responsable du contenu qu'il partage et de ses destinataires.
    </P>

    <H2 id="donnees">Données personnelles</H2>
    <P>
      Le traitement des données est décrit dans la
      <Link to="/confidentialite" className="text-emerald-600 underline"> politique de confidentialité</Link>.
    </P>

    <H2 id="droit-applicable">Droit applicable</H2>
    <P>Le droit applicable et la juridiction compétente seront précisés dans la version définitive.</P>

    <Notice testid="terms-work-note">
      Version de travail à valider juridiquement avant production commerciale.
    </Notice>
  </Page>
);

export default TermsPage;
